export class ArticleModel {
  articleId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  alterCode2: string | null = null;
  name: string = '';
  familyId: number = 0;
  groupId: number = 0;
  subgroupId: number = 0;
  typeArticleId: number = 0;
  typeInventoryId: number = 0;
  rentalUnitId: number = 0;
  inventoryUnitId: number = 0;
  active: boolean = true;
  weight: number = 0;
  replacementValue: number = 0;
  saleValue: number = 0;
  minorRepairValue: number = 0;
  mayorRepairValue: number = 0;
  cleaningValue: number = 0;
  areaM2: number = 0;
  observation: string | null = null;
  occupancyPercentageReport: boolean = true;
  daysInConstructionSiteReport: boolean = true;
  swAffectsInventory: boolean = false;
  swGeneric: boolean = false;
  genericId: number | null = null;
  imageArticle: string | null = null;
  swDirectDevolutionWorkshop: boolean = false;
  swEquipmentLogbook: boolean = false;
  equipmentLogbookId: number | null = null;
  equipmentLogbookConsecutive: number | null = null;
  swOwn: boolean = true;
  swRoutine: boolean = false;
  swPurchase: boolean = false;
  swSale: boolean = false;
  swRequiresPurchaseOrder: boolean = false;
  conceptInvoicingId: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  image1: string | null = null;
  image2: string | null = null;
  image3: string | null = null;
  mainImage: string | null = null;
  accountingCostCenter: string | null = null;
}
